import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
// console.log(BASE_URL);

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});
instance.interceptors.request.use(
  function (config) {
    if (
      config.url !== "auth/login" &&
      config.url !== "admin/contactus" &&
      config.url !== "admin/demo"
    ) {
      config.headers = {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      };
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    const { token } = response.data;
    if (token) {
      sessionStorage.setItem("token", token);
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export function login(user) {
  console.log("User", user);
  return instance.post("auth/login", user);
}
export function changePassword(newpassword) {
  return instance.post("auth/change_password", newpassword);
}

export function forgotPassword(data) {
  // console.log("DATA FORGOT", data);
  return instance.post("auth/forgot_password", data);
}

export function changeForgotPassword(data) {
  // console.log("CHANGE FORGOT", data);
  return instance.post("auth/change_forgot_password", data);
}

export function getStates() {
  return instance.get("common/states");
}

export function getCountries() {
  return instance.get("common/countries");
}

export function contactUs(data) {
  console.log("Data is ", data);
  return instance.post("common/contactus", data);
}

export function requestDemo(data) {
  console.log("Data is ", data);
  return instance.post("common/demo", data);
}
export const authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    sessionStorage.setItem("ncwf", JSON.stringify(data));
    next();
  }
};

export function isAuthenticated() {
  const token = sessionStorage.getItem("token");
  console.log("Authenticated ");
  return !!token;
}

export function getSchools() {
  return instance.get("admin/schools");
}

export function getPaymentPlans() {
  return instance.get("admin/payment_plans");
}

export function addSchool(data) {
  return instance.post("admin/add_school", data);
}

export function lockSchool(id) {
  return instance.post(`admin/lock_school/${id}`);
}

export function unlockSchool(id) {
  return instance.post(`admin/unlock_school/${id}`);
}

export function activatePlan(id) {
  return instance.post(`admin/activate_plan/${id}`);
}

export function deactivatePlan(id) {
  return instance.post(`admin/deactivate_plan/${id}`);
}

export function addPlan(data) {
  return instance.post("admin/add_payment_plan", data);
}

export function addSchoolAdmin(data) {
  return instance.post("admin/add_school_admin", data);
}

export function getGrades() {
  return instance.get("sadmin/grades");
}

export function addGrade(data) {
  return instance.post("sadmin/add_grade", data);
}

export function updateGradeStatus(id, data) {
  return instance.post(`sadmin/update_grade/${id}`, data);
}

export function getSections() {
  return instance.get("sadmin/sections");
}

export function addSection(data) {
  return instance.post("sadmin/add_section", data);
}

export function updateSectionStatus(id, data) {
  return instance.post(`sadmin/update_section/${id}`, data);
}

export function getSubjects() {
  return instance.get("sadmin/subjects");
}

export function addSubject(data) {
  return instance.post("sadmin/add_subject", data);
}

export function updateSubjectStatus(id, data) {
  return instance.post(`sadmin/update_subject/${id}`, data);
}
export function getAcademicSessions() {
  return instance.get("sadmin/academic_sessions");
}

export function addAcademicSession(data) {
  return instance.post("sadmin/add_academic_session", data);
}

export function updateAcademicSessionStatus(id, data) {
  return instance.post(`sadmin/update_academic_session/${id}`, data);
}

export function getTimeIntervals() {
  return instance.get("sadmin/time_intervals");
}

export function addTimeInterval(data) {
  return instance.post("sadmin/add_time_interval", data);
}

export function updateTimeIntervalStatus(id, data) {
  return instance.post(`sadmin/update_time_interval/${id}`, data);
}

export function getTeachers() {
  return instance.get("sadmin/teachers");
}

export function addTeacher(data) {
  return instance.post("sadmin/add_teacher", data);
}

export function updateTeacherStatus(id, data) {
  return instance.post(`sadmin/update_teacher/${id}`, data);
}

export function getClasses() {
  return instance.get("sadmin/classes");
}

export function addClass(data) {
  return instance.post("sadmin/add_class", data);
}

export function updateClassStatus(id, data) {
  return instance.post(`sadmin/update_class/${id}`, data);
}

export function classSchedule(data) {
  return instance.post("sadmin/class_schedule", data);
}

export function updateClassSchedule(data) {
  return instance.post("sadmin/update_class_schedule", data);
}

export function getStudentsByClassId(id) {
  return instance.get(`sadmin/students_by_class/${id}`);
}

export function registerStudent(body) {
  return instance.post("sadmin/register_student", body);
}

export function getStudentInfo(id) {
  return instance.get(`sadmin/student_info/${id}`);
}

export function updateStudentInfo(data) {
  return instance.post("sadmin/update_student_info", data);
}

export function uploadSchoolLogo(data) {
  return instance.post("sadmin/upload_school_logo", data);
}

export function getSchoolLogo(id) {
  return instance.get(`sadmin/school_logo/${id}`);
}

export function uploadUserImage(data) {
  console.log("DATA", data, typeof data);
  return instance.post("user/upload_profile_pic", data);
}

export function getSchoolInfo(id) {
  return instance.get(`user/school_info/${id}`);
}

export function getUserInfo(id) {
  return instance.get(`user/user_info/${id}`);
}

export function getDashBoardData() {
  return instance.get(`sadmin/dashboard_data`);
}

export function getHolidaysBySessionId(id) {
  return instance.get(`sadmin/holidays/${id}`);
}

export function addHoliday(data) {
  return instance.post("sadmin/add_holiday", data);
}

export function deleteHoliday(id) {
  return instance.delete(`sadmin/delete_holiday/${id}`);
}

export function getSchoolFees(id) {
  return instance.get(`fees/school_fees/${id}`);
}

export function addSchoolFee(data) {
  return instance.post("fees/add_school_fee", data);
}

export function getFeeTypes() {
  return instance.get("common/fee_types");
}

export function getStudentApplicableFees(id) {
  return instance.get(`fees/get_student_applicable_fees/${id}`);
}

export function getStudentFees(id) {
  return instance.get(`fees/student_fees/${id}`);
}

export function getPaymentFrequencies() {
  return instance.get("fees/payment_frequencies");
}

export function addStudentFee(data) {
  return instance.post("fees/add_student_fee", data);
}

export function getFeesHistory(selectedStudentId, selectedSessionId) {
  console.log(selectedStudentId, selectedSessionId);
  return instance.get(
    `fees/student_fees_history/${selectedStudentId}/${selectedSessionId}`
  );
}

export function payFees(data) {
  return instance.post("fees/pay_student_fee", data);
}

export function getDocumentList() {
  return instance.get("admin/document_list");
}

export function uploadUserDocument(studentId, documentName, data) {
  return instance.post(
    `sadmin/upload_student_document/${studentId}/${documentName}`,
    data
  );
}

export function getDocumentsByStudentId(id) {
  return instance.get(`sadmin/student_document_list/${id}`);
}

export function requestPayment(historyFeeId) {
  return instance.post(`fees/send_payment_request/${historyFeeId}`);
}

export function downloadFeesReceipt(historyFeeId) {
  return instance.get(`fees/download_fee_receipt/${historyFeeId}`);
}

export function addBookFee(data) {
  return instance.post("fees/add_book_fee", data);
}

export function getBooksFeeDetails(studentId, sessionId) {
  return instance.get(
    `/fees/student_books_fee_history/${studentId}/${sessionId}`
  );
}
export function downloadBooksFeeReceipt(feeId) {
  return instance.get(`/fees/download_books_fee_receipt/${feeId}`);
}

export function getExpenses(schoolId) {
  return instance.get(`sadmin/expenses/${schoolId}`);
}

export function addExpense(data) {
  return instance.post(`sadmin/add_expense`, data);
}

export function getExpenseCategory(schoolId) {
  return instance.get(`sadmin/expenses/categories/${schoolId}`);
}

export function addExpenseCategory(data) {
  return instance.post(`sadmin/add_expense_category`, data);
}

export function updateStudent(data) {
  return instance.post(`sadmin/update_student`, data);
}

export function deleteFee(studentId, feesId) {
  return instance.post(`/fees/delete_student_fee/${studentId}/${feesId}`);
}

export function dashboardStudentsData(sessionId, schoolId) {
  return instance.get(`dashboard/students/${sessionId}/${schoolId}`);
}

export function dashboardPendingFeesData(sessionId, schoolId) {
  return instance.get(`dashboard/pending_fee/${sessionId}/${schoolId}`);
}

export function dashboardExpensesData(sessionId, schoolId) {
  return instance.get(`dashboard/expense/${sessionId}/${schoolId}`);
}

export function dashboardRevenueData(sessionId, schoolId) {
  return instance.get(`dashboard/revenue/${sessionId}/${schoolId}`);
}

export function requestPendingFeePayment(studentId) {
  return instance.get(`dashboard/request_payment/${studentId}`);
}

export function dashboardExpVsRevData(sessionId, schoolId) {
  return instance.get(`dashboard/expvsrev/${sessionId}/${schoolId}`);
}
